import { CasingLiner } from '../src/app/interfaces/casing-liner';

export const CASING_LINER: CasingLiner[] = [
  {
    handoverId: 42,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    assemblyId: 'HRKiv',
    wellboreNo: 'OH',
    assemblyName: 'CASING',
    holeSize: 13.499999999999998,
    mdLanded: 406,
    mdLinerTop: 0,
    tvdLanded: 0,
    mdMarkerTop: 0,
    comment: '',
    groupValues: [
      {
        assemblyCompId: 'j5Ygh',
        nominalSize: 9.625,
        weight: 36,
        grade: 'K-55',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'j5Ygh',
        nominalSize: 9.625,
        weight: 36,
        grade: 'K-56',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'j5Ygh',
        nominalSize: 9.625,
        weight: 36,
        grade: 'K-57',
        threads: '8R LT+C',
      },
    ],
  },
  {
    handoverId: 42,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    assemblyId: 'HRKiv',
    wellboreNo: 'OH',
    assemblyName: 'CASING',
    holeSize: 13.499999999999998,
    mdLanded: 406,
    mdLinerTop: 0,
    tvdLanded: 0,
    mdMarkerTop: 1.5,
    comment: '',
    groupValues: [
      {
        assemblyCompId: 'rvEV7',
        nominalSize: 9.625,
        weight: 32.3,
        grade: 'H-40',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'rvEV7',
        nominalSize: 9.625,
        weight: 32.3,
        grade: 'H-40',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'rvEV7',
        nominalSize: 9.625,
        weight: 32.3,
        grade: 'H-40',
        threads: '8R LT+C',
      },
    ],
  },
  {
    handoverId: 42,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    assemblyId: 'HRKiv',
    wellboreNo: 'OH',
    assemblyName: 'CASING',
    holeSize: 13.499999999999998,
    mdLanded: 406,
    mdLinerTop: 0,
    tvdLanded: 0,
    mdMarkerTop: 2.56,
    comment: '',
    groupValues: [
      {
        assemblyCompId: 'EboQ7',
        nominalSize: 9.625,
        weight: 32.3,
        grade: 'H-40',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'EboQ7',
        nominalSize: 9.625,
        weight: 32.3,
        grade: 'H-40',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'EboQ7',
        nominalSize: 9.625,
        weight: 32.3,
        grade: 'H-40',
        threads: '8R LT+C',
      },
    ],
  },
  {
    handoverId: 42,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    assemblyId: '7lqDd',
    wellboreNo: 'OH',
    assemblyName: 'CASING',
    holeSize: 8.75,
    mdLanded: 2467.36,
    mdLinerTop: 0,
    tvdLanded: 0,
    mdMarkerTop: 0,
    comment: '',
    groupValues: [
      {
        assemblyCompId: 'JS7VO',
        nominalSize: 5.5,
        weight: 14,
        grade: 'K-55',
        threads: '8R ST+C',
      },
      {
        assemblyCompId: 'JS7VO',
        nominalSize: 5.5,
        weight: 14,
        grade: 'K-55',
        threads: '8R ST+C',
      },
      {
        assemblyCompId: 'JS7VO',
        nominalSize: 5.5,
        weight: 14,
        grade: 'K-55',
        threads: '8R ST+C',
      },
    ],
  },
  {
    handoverId: 42,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    assemblyId: '7lqDd',
    wellboreNo: 'OH',
    assemblyName: 'CASING',
    holeSize: 8.75,
    mdLanded: 2467.36,
    mdLinerTop: 0,
    tvdLanded: 0,
    mdMarkerTop: null,
    comment: '',
    groupValues: [
      {
        assemblyCompId: 'ZhpqV',
        nominalSize: 5.5,
        weight: 17,
        grade: 'K-55',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'ZhpqV',
        nominalSize: 5.5,
        weight: 17,
        grade: 'K-55',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'ZhpqV',
        nominalSize: 5.5,
        weight: 17,
        grade: 'K-55',
        threads: '8R LT+C',
      },
    ],
  },
  {
    handoverId: 42,
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    assemblyId: '7lqDd',
    wellboreNo: 'OH',
    assemblyName: 'CASING',
    holeSize: 8.75,
    mdLanded: 2467.36,
    mdLinerTop: 0,
    tvdLanded: 0,
    mdMarkerTop: 0,
    comment: '',
    groupValues: [
      {
        assemblyCompId: 'kQV6E',
        nominalSize: 5.5,
        weight: 15.5,
        grade: 'K-55',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'kQV6E',
        nominalSize: 5.5,
        weight: 15.5,
        grade: 'K-55',
        threads: '8R LT+C',
      },
      {
        assemblyCompId: 'kQV6E',
        nominalSize: 5.5,
        weight: 15.5,
        grade: 'K-55',
        threads: '8R LT+C',
      },
    ],
  },
];
